import styles from './styles.module.scss'

import { Helmet } from 'react-helmet';

import { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { UserContext } from '@/context/user';

import { Button, Card, Modal } from 'antd';
import { ShareAltOutlined } from '@ant-design/icons';

export const PageUser = () => {
  const history = useHistory()

  const {
    ready,
    debugMode,
    ga4Attr,
    uaAttr,
    tagManagerAttr,
    optimizeAttr,
    userId,
    resetUserContext,
  } = useContext(UserContext)

  const onShareClick = () => {
    if (ga4Attr?.id) {
      const gaId = ga4Attr.id
      const message = `https://www.turtlebooks.co.kr/ga4/user?tempGaId=${gaId}`
      Modal.info({
        title: '아래 공유 링크를 복사해서 사용하세요',
        content: (
          <div>
            <p>{message}</p>
          </div>
        ),
        onOk() {},
      });
    }
  }

  return (
    <>
      <Helmet>
        <title>구글 애널리틱스는 사용자를 어떻게 구분할까?</title>
      </Helmet>
      <div className={styles.body}>
        <Card title="구글 애널리틱스는 사용자를 어떻게 구분할까?">
          {
            ga4Attr?.id && (
              <Button size="large" type="primary" onClick={() => onShareClick()}>
                사용자 확인 링크
              </Button>
            )
          }
          {
            !(ga4Attr?.id) && (
              <p>실시간 보고서를 확인해주세요</p>
            )
          }
        </Card>
      </div>
    </>
  )
}